import { useFormContext } from "react-hook-form";
import { cn } from "@/shared/lib/cn";
import { Button, type ButtonProps } from "../core/Button/Button";

export type SubmitButtonProps = Omit<ButtonProps, "type">;

/**
 * El botón que envía el formulario. Saca `loading` del propio formulario,
 * así que ninguna pantalla vuelve a escribir `loading={isSubmitting}` —
 * que es justo la línea que se olvida y deja el botón enviando dos veces.
 *
 * El `mt-1` va aquí porque el separador extra antes de la acción es parte
 * del ritmo del formulario, no una decisión de cada pantalla: los dos
 * formularios de acceso lo repetían idéntico. `cn()` resuelve conflictos,
 * así que `className="mt-4"` lo sustituye sin pelear.
 */
export function SubmitButton({ loading, className, ...rest }: SubmitButtonProps) {
  const { formState } = useFormContext();

  return (
    <Button
      type="submit"
      loading={loading ?? formState.isSubmitting}
      className={cn("mt-1", className)}
      {...rest}
    />
  );
}
